export default __webpack_public_path__ + "static/media/smoothie-7.20492b15.svg";